import { getCompatibleAuthTokenHttp } from 'src/services/utils/enhancedAuthTokenHttp';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { MutationFunction } from '@tanstack/react-query';

export interface DocumentGroupingConfiguration {
  required: boolean;
  validityRule: string;
  filesPerBorrower: number;
  documentTypeId: string;
}

export interface CreateDocumentGroupingParams {
  name: string;
  configuration: DocumentGroupingConfiguration[];
}

export interface CreateDocumentGroupingResponse {
  success: boolean;
  id: string;
  message: string;
}

const createDocumentGrouping: MutationFunction<
  CreateDocumentGroupingResponse,
  CreateDocumentGroupingParams
> = async (args) => {
  if (isMockServices()) return await mock(_mockData);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<CreateDocumentGroupingResponse>(
    `/document-groupings`,
    {
      method: 'POST',
      body: {
        name: args.name,
        configuration: args.configuration,
      },
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to create document grouping');
};

export default createDocumentGrouping;

const _mockData: CreateDocumentGroupingResponse = {
  success: true,
  id: 'mock-created-id',
  message: 'Document grouping created successfully.',
};
